import { DateTimeFilterContainer, DateTimeFilterWrapper } from './styles';
import React, { useEffect } from 'react';

import { PriceComponent } from './components/price-component';
import { resetPrice } from 'store/price/actions';
import { useDispatch } from 'react-redux';
import { useSelectedDateTimeFilter } from './hooks/use-selected-date-time-filter.hook';
import { DateTimeLinks } from './components/date-time-links';
import { MultipleBookings } from './components/multiple-bookings';

interface SelectedDateTimeFilterProps {
  onDateClick?: VoidFunction;
  onTimeClick?: VoidFunction;
  isSelectedDateTimeFilterTextOnly?: boolean;
  resourceContainerRef?: React.MutableRefObject<HTMLDivElement>;
  showDateTimeLinks?: boolean;
}

export const SelectedDateTimeFilter = ({
  onDateClick,
  onTimeClick,
  isSelectedDateTimeFilterTextOnly,
  resourceContainerRef,
  showDateTimeLinks = true,
}: SelectedDateTimeFilterProps): JSX.Element => {
  const dispatch = useDispatch();
  const {
    price,
    minimumPrice,
    startTime,
    endTime,
    priceStatus,
    buildingLocale,
    showMinimumPrice,
    showFreeLabel,
    containerHeight,
    toggleMultipleBookingsVisibility,
    isMultipleBookingsVisible,
    reverseAnimation,
  } = useSelectedDateTimeFilter(resourceContainerRef);

  useEffect(() => {
    if (!startTime && !endTime) {
      dispatch(resetPrice());
    }
  }, [startTime, endTime, dispatch]);

  return (
    <DateTimeFilterWrapper>
      <DateTimeFilterContainer areDateTimeLinksVisible={showDateTimeLinks}>
        {showDateTimeLinks && (
          <DateTimeLinks
            toggleMultipleBookingsVisibility={toggleMultipleBookingsVisibility}
            isMultipleBookingsVisible={isMultipleBookingsVisible}
            isSelectedDateTimeFilterTextOnly={isSelectedDateTimeFilterTextOnly}
            onDateClick={onDateClick}
            onTimeClick={onTimeClick}
          />
        )}
        <PriceComponent
          price={price}
          minimumPrice={minimumPrice}
          priceStatus={priceStatus}
          locale={buildingLocale}
          showMinimumPrice={showMinimumPrice}
          showFreeLabel={showFreeLabel}
          hasContentBelow={showDateTimeLinks}
        />
      </DateTimeFilterContainer>
      <MultipleBookings
        containerHeight={containerHeight}
        onDateClick={onDateClick}
        onTimeClick={onTimeClick}
        reverseAnimation={reverseAnimation}
      />
    </DateTimeFilterWrapper>
  );
};
